import { DropdownOptionModel } from '@Common/Forms/models/dropdown-option.model';
import { AlertSurgeMetricEnum } from '../enums/alert-surge-metric.enum';

export const alertSurgeMetricOptions: DropdownOptionModel[] = [
    new DropdownOptionModel(`Alerts.surge.metrics.${AlertSurgeMetricEnum.MENTION_VOLUME}`, AlertSurgeMetricEnum.MENTION_VOLUME),
    new DropdownOptionModel(`Alerts.surge.metrics.${AlertSurgeMetricEnum.IMPRESSIONS}`, AlertSurgeMetricEnum.IMPRESSIONS),
    new DropdownOptionModel(`Alerts.surge.metrics.${AlertSurgeMetricEnum.SENTIMENT}`, AlertSurgeMetricEnum.SENTIMENT),
];
